import { render, staticRenderFns } from "./AdmissionConsult.vue?vue&type=template&id=e968a154&scoped=true"
import script from "./AdmissionConsult.vue?vue&type=script&lang=js"
export * from "./AdmissionConsult.vue?vue&type=script&lang=js"
import style0 from "./AdmissionConsult.vue?vue&type=style&index=0&id=e968a154&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e968a154",
  null
  
)

export default component.exports